import { SkillEnum } from '@minecraft.graphql-operations';
import { gqlSkillEnum as skill } from '@minecraft.graphql-types';
import { useTranslation } from '@blocs.i18n';

const skillText = {
  [skill.ACTING_STYLES]: 'common:skill.label.acting_styles',
  [skill.BAND_STYLES]: 'common:skill.label.band_styles',
  [skill.CIRCUS_SKILLS]: 'common:skill.label.circus_skills',
  [skill.DANCE]: 'common:skill.label.dance',
  [skill.DIALECTS]: 'common:skill.label.dialects',
  [skill.DRIVING_BOATING_PILOTING]: 'common:skill.label.driving_boating_piloting',
  [skill.HOBBIES]: 'common:skill.label.hobbies',
  [skill.INSTRUMENTS]: 'common:skill.label.instruments',
  [skill.JOBS]: 'common:skill.label.jobs',
  [skill.LANGUAGES]: 'common:skill.label.languages',
  [skill.MILITARY]: 'common:skill.label.military',
  [skill.PERFORMANCE_SKILLS]: 'common:skill.label.performance_skills',
  [skill.RODEO]: 'common:skill.label.rodeo',
  [skill.SINGING_STYLES]: 'common:skill.label.singing_styles',
  [skill.SPORTS]: 'common:skill.label.sports',
  [skill.STUNTS]: 'common:skill.label.stunts',
  [skill.VOCAL_RANGE]: 'common:skill.label.vocal_range',
  [skill.WEAPONS_FIREARMS]: 'common:skill.label.weapons_firearms',
  [skill.SPORTS_COMBAT_SPORTS]: 'common:skill.label.sports_combat_sports',
  [skill.SPORTS_EQUESTRIAN_SPORTS]: 'common:skill.label.sports_equestrian_sports',
  [skill.SPORTS_CYCLING]: 'common:skill.label.sports_cycling',
  [skill.SPORTS_EXTREME_SPORTS]: 'common:skill.label.sports_extreme_sports',
  [skill.SPORTS_GYM_SPORTS]: 'common:skill.label.sports_gym_sports',
  [skill.SPORTS_GYMNASTIC_SPORTS]: 'common:skill.label.sports_gymnastic_sports',
  [skill.SPORTS_MARTIAL_ARTS]: 'common:skill.label.sports_martial_arts',
  [skill.SPORTS_OUTDOOR_SPORTS]: 'common:skill.label.sports_outdoor_sports',
  [skill.SPORTS_RACQUET_SPORTS]: 'common:skill.label.sports_racquet_sports',
  [skill.SPORTS_RECREATIONAL_SPORTS]: 'common:skill.label.sports_recreational_sports',
  [skill.SPORTS_TABLE_SPORTS]: 'common:skill.label.sports_table_sports',
  [skill.SPORTS_TEAM_SPORTS]: 'common:skill.label.sports_team_sports',
  [skill.SPORTS_TRACK_AND_FIELD]: 'common:skill.label.sports_track_and_field',
  [skill.SPORTS_WATER_SPORTS]: 'common:skill.label.sports_water_sports',
  [skill.SPORTS_WINTER_SPORTS]: 'common:skill.label.sports_winter_sports',
};

// Note: These could be typed from the skill enums, but only a subset are supported, and the goal is for these to be replaced with backend translations
export const useSkillText = () => {
  const { t } = useTranslation();

  return (skillCode: SkillEnum) => {
    const skillKey = skillText?.[skillCode];
    if (!skillKey) {
      return '';
    }

    return t(skillText[skillCode]);
  };
};
